export default __webpack_public_path__ + "assets/a94438ee46159efb1dd62640ce83def6.png";